import React from 'react';

// Fake component for use in preview only
export default function FakeAttachmentViewNoPreviewSmall() {

    return (
        <div className="ui5-attachment-no-preview-small">
            <div className="preview">
                <div className="ui5-ico-14 i5-attachment"/>
            </div>
            <div className="details">
                <div className="file-name ui5-txt-less-important-tiny txt-truncate">
                    File name.txt
                </div>
            </div>
            <div className="overlay-details">
                <div className="file-size ui5-txt-not-important-tiny">1Mb</div>
                <div className="actions">
                    <div className="ui5-ico-round red i5-trash-alt m-r-5"/>
                    <div className="ui5-ico-round i5-download"/>
                </div>
            </div>
        </div>
    )
}
